module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/attraction-icon-1e54b64a7922cd5a82db8e375448a5ba.png";